import React from "react";

import { VariantType } from "@/styles/components/table/StyledTableCellText";
import { StyledFlexRow, StyledTableCell, StyledTableCellItem, StyledTableCellText } from "@/styles/styled";

export type MaxLinesCellProps = {
    variant?: VariantType;
    highlight: boolean;
    maxLines: number;
    testId: string;
    children: React.ReactElement | string;
    icon?: React.ReactElement;
};
const MaxLinesCell = ({
    variant = "normal",
    highlight = false,
    maxLines = 3,
    testId,
    children,
    icon,
}: MaxLinesCellProps): React.ReactElement => {
    const innerTextContent = (
        <StyledTableCellItem $maxLines={maxLines}>
            <StyledTableCellText $variant={variant} $highlight={highlight}>
                {children}
            </StyledTableCellText>
        </StyledTableCellItem>
    );
    const innerContent = icon ? (
        <StyledFlexRow>
            {icon}
            {innerTextContent}
        </StyledFlexRow>
    ) : (
        innerTextContent
    );

    return (
        <StyledTableCell data-testid={testId} $noEllipsis>
            {innerContent}
        </StyledTableCell>
    );
};

export default MaxLinesCell;
